import { RoutesEnum } from '@monofront/types';

export const ROUTES = {
  [RoutesEnum.SUBSCRIPTION_PAYMENT]: {
    fr: {
      path: '/account/register/flow',
    },
    de: {
      path: '/account/register/flow',
    },
  },
  [RoutesEnum.SUBSCRIPTION_CONFIRMATION]: {
    fr: {
      path: '/home',
    },
    de: {
      path: '/home',
    },
  },
  [RoutesEnum.NEW_SUBSCRIPTION_CONFIRMATION]: {
    fr: {
      path: '/account/register/congrats',
    },
    de: {
      path: '/account/register/congrats',
    },
  },
  [RoutesEnum.LISTS_RECOMMENDATIONS]: {
    fr: {
      path: '/pages/mes-recommandations',
    },
    de: {
      path: '/pages/my-recommendations',
    },
  },
  [RoutesEnum.LEGAL_CONDITIONS]: {
    fr: {
      path: '/pages/cgv-cgu',
    },
    de: {
      path: '/pages/agb',
    },
  },
  [RoutesEnum.CGV]: {
    fr: {
      path: '/pages/cgv-1',
    },
    de: {
      path: '/pages/agb',
    },
  },
  [RoutesEnum.CGU]: {
    fr: {
      path: '/pages/cgu-1',
    },
    de: {
      path: '/pages/agb',
    },
  },
  [RoutesEnum.PRIVACY_POLICIES]: {
    fr: {
      path: '/pages/protection-des-donnees',
    },
    de: {
      path: '/pages/datenschutzerklaerung',
    },
  },
  [RoutesEnum.SUPPORT_NEW_REQUEST_URL]: {
    fr: {
      url: 'https://support.lafourche.fr/hc/fr/requests/new',
    },
    de: {
      url: 'https://support.ackerherz.de/hc/de/requests/new',
    },
  },
  [RoutesEnum.APP_STORE_URL]: {
    fr: {
      url: 'https://apps.apple.com/fr/app/la-fourche-magasin-bio/id1592271294',
    },
    de: {
      url: 'https://apps.apple.com/de/app/ackerherz/id6794122142',
    },
  },
  [RoutesEnum.PLAY_STORE_URL]: {
    fr: {
      url: 'https://play.google.com/store/apps/details?id=fr.lafourche.app.release',
    },
    de: {
      url: 'https://play.google.com/store/apps/details?id=de.ackerherz.app.release',
    },
  },
  [RoutesEnum.APP_STORE_BADGE_IMAGE]: {
    fr: {
      path: '/images/app-mobile/fr/badge-app-store.svg',
    },
    de: {
      path: '/images/app-mobile/de/badge-app-store.svg',
    },
  },
  [RoutesEnum.PLAY_STORE_BADGE_IMAGE]: {
    fr: {
      path: '/images/app-mobile/fr/badge-play-store.svg',
    },
    de: {
      path: '/images/app-mobile/de/badge-play-store.svg',
    },
  },
  [RoutesEnum.APP_DOWNLOAD_QR_CODE_IMAGE]: {
    fr: {
      path: '/images/app-mobile/fr/qrcode.png',
    },
    de: {
      path: '/images/app-mobile/de/qrcode.png',
    },
  },
  [RoutesEnum.ESSENTIALS_COLLECTION]: {
    fr: {
      path: '/collections/les-essentiels-1',
    },
    de: {
      path: '/collections/unsere-auswahl-de',
    },
  },
  [RoutesEnum.FRESH_COLLECTION]: {
    fr: {
      path: '/collections/fruits-et-legumes-bio',
    },
    de: {
      path: '',
    },
  },
  [RoutesEnum.BLOG_URL]: {
    fr: {
      url: 'https://blog.lafourche.fr',
    },
    de: {
      url: '',
    },
  },
  [RoutesEnum.MAAP_CARD_IMAGE]: {
    fr: {
      path: 'https://images.prismic.io/la-fourche/Zum6YbVsGrYSvd38_maapcard.png',
    },
    de: {
      path: 'https://images.prismic.io/la-fourche/Zx9jmK8jQArTz39v_maapcard-de.png',
    },
  },
  [RoutesEnum.PRODUCT_PAGE]: {
    fr: {
      path: '/products',
    },
    de: {
      path: '/products',
    },
  },
  [RoutesEnum.MANAGE_MY_SUBSCRIPTION]: {
    fr: { path: '/pages/manage-my-subscription' },
    de: { path: '/pages/manage-my-subscription' },
  },
};
